<template>
    <div class="templete_box">
        <div class="crumbsNav clearfix">
            <div class="navSon navSonChecked">
                板材采购
            </div>
            <div class="navSon">
                原木采购
            </div>
            <!-- <div class="navSon">
                北美材采购
            </div> -->
        </div>
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="params.timeStart" class="search_time_input" type="date" placeholder="合同开始"></el-date-picker>
                    ~
                    <el-date-picker v-model="params.timeEnd" class="search_time_input" type="date" placeholder="合同结束"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" placeholder="订单状态"></el-input>
                <el-input class="search_input search_inputBox" placeholder="合同号"></el-input>
                <el-input class="search_input search_inputBox" placeholder="供应商"></el-input>
                <el-input class="search_input search_inputBox" placeholder="提单号"></el-input>
                <el-select class="search_select search_inputBox" placeholder="品种">
                    <el-option label="item.label" value="item.value"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" placeholder="入库时间">
                    <el-option label="item.label" value="item.value"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" placeholder="采购类型">
                    <el-option label="item.label" value="item.value"></el-option>
                </el-select>
                <div class="reset fcolor">重置</div>
                <el-button  class="publicBtn" @click="changetable">查询</el-button>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn" @click="isShowContract=!isShowContract">添加合同</el-button>
                <el-button class="funcPublicBtn" @click="isShowCost=!isShowCost">添加费用</el-button>
                <!-- <el-button class="funcPublicBtn">捆包明细</el-button> -->
            </div>
            <div class="tableBox">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="tableData" @getRow="getRow" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <el-dialog v-dialog-drag :visible.sync="isShowContract" class="eldialog eldialogA" width="580px" :modal="false" title="添加合同" custom-class="full_dialog">
            <el-form :rules="contractRules" :model="contractForm" class="clearfix">
                <div class="eldialogFormBox">
                    <el-form-item  label="货权单位：" prop="realname">
                        <el-select>
                            <el-option></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="供应商：" prop="admin_id">
                        <el-select>
                            <el-option></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="合同号：" prop="contact">
                        <el-input v-model="contractForm.realname"></el-input>
                    </el-form-item>
                    <el-form-item  label="合同日期：" prop="realname">
                        <el-date-picker v-model="contractForm.realname" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="货柜：" prop="admin_id">
                        <el-input v-model="contractForm.realname"></el-input>
                    </el-form-item>
                    <el-form-item  label="预计发货：" prop="contact">
                        <el-input v-model="contractForm.realname"></el-input>
                    </el-form-item>
                    <el-form-item  label="预计到港：" prop="realname">
                        <el-input v-model="contractForm.realname"></el-input>
                    </el-form-item>
                    <el-form-item  label="目的港：" prop="admin_id">
                        <el-select>
                            <el-option></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="品种：" prop="contact">
                        <el-select>
                            <el-option></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="长度：" prop="realname">
                        <el-select>
                            <el-option></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="厚度：" prop="admin_id">
                        <el-select>
                            <el-option></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="立方：" prop="contact">
                        <el-input v-model="contractForm.realname"></el-input>
                    </el-form-item>
                    <el-form-item  label="外币总金额：" prop="realname">
                        <el-input v-model="contractForm.realname"></el-input>
                    </el-form-item>
                    <el-form-item  label="RMB总金额：" prop="admin_id">
                        <el-input v-model="contractForm.realname"></el-input>
                    </el-form-item>
                    <el-form-item  label="付款方：" prop="contact">
                        <el-input v-model="contractForm.realname"></el-input>
                    </el-form-item>
                    <el-form-item  label="订单状态：" prop="realname">
                        <el-select>
                            <el-option></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="admin_id">
                        <el-input v-model="contractForm.realname"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag :visible.sync="isShowCost" class="eldialog eldialogB" width="900px" :modal="false" title="添加费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form :model="contractForm" class="clearfix dialogFormB">
                    <div class="elFormBox">
                        <el-form-item  label="日期：" prop="realname">
                            <el-input v-model="contractForm.realname"></el-input>
                        </el-form-item>
                        <el-form-item  label="费用名称：" prop="realname">
                            <el-select>
                                <el-option></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="提供发票：" prop="realname">
                            <el-select>
                                <el-option></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="合同号：" prop="realname">
                            <el-select>
                                <el-option></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="收款人(单位)：" prop="realname">
                            <el-select>
                                <el-option></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="备注：" prop="realname">
                            <el-input v-model="contractForm.realname"></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="提单号：" prop="realname">
                            <el-select>
                                <el-option></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="金额(￥)：" prop="realname">
                            <el-input v-model="contractForm.realname"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="editBox">
                    <div class="editTitle">历史费用</div>
                    <div class="editList">
                        <el-table :data="costTable" border stripe highlight-current-row size="mini" height="100%">
                            <el-table-column type="index" align="center" width="40"></el-table-column>
                            <el-table-column label="操作"  width="45">
                                <template>
                                    <div class="icon_wrap">
                                        <i class="operation_delete" title="删除"></i>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="添加日期" prop="date" width="70" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                            <el-table-column label="费用名称" prop="date" width="70" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                            <el-table-column label="金额" prop="date" width="60" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                            <el-table-column label="收款单位(个人)" prop="date" width="90" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                            <el-table-column label="付款状态" prop="date" width="70" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                            <el-table-column label="是否开票" prop="date" width="70" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                            <el-table-column label="发票状态" prop="date" width="70" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                            <el-table-column label="合同号" prop="date" width="70" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                            <el-table-column label="提单号" prop="date" width="60" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                            <el-table-column label="经办人" prop="date" width="60" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" prop="date" width="70" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ scope.row.date }}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                costTable:[
                    {date:""}
                ],
                isShowContract:false,
                isShowCost:false,
                contractForm:{
                    realname:""
                },
                contractRules: {
					realname : [ { required: true, message: '请填写真实姓名', trigger: 'blur' }],
					admin_id : [ { required: true, message: '请选择销售员', trigger: 'change' }],
					contact : [ { required: true, message: '请填写真实姓名', trigger: 'blur'  }]
                },
                params:{
                    timeStart:"",
                    timeEnd:"",
                    per_page:100
                },
                tableCol:[
                    {colName:"表格",colKey:"name",colWidth:130,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"表格1",colKey:"nameA",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"表格2",colKey:"nameB",colWidth:100,isSetWidth:true,isCanClick:true,isShow:true},
                    {colName:"表格1",colKey:"nameC",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"表格3",colKey:"nameD",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"表格1",colKey:"nameE",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"表格1",colKey:"nameF",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"表格1",colKey:"nameG",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"表格1",colKey:"nameH",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"表格1",colKey:"nameI",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"表格1",colKey:"nameJ",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"表格1",colKey:"nameK",colWidth:100,isSetWidth:false,isCanClick:false,isShow:true}
                ],
                tableData:[
                    {id:1,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:true,isSee:false},
                    {id:2,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:true,isSee:false},
                    {id:3,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:true,isSee:false},
                    {id:4,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:false,isSee:true},
                    {id:5,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:true,isSee:false},
                    {id:6,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:true,isSee:false},
                    {id:7,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:true,isSee:false},
                    {id:8,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:false,isSee:true},
                    {id:9,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:true,isSee:false},
                    {id:10,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:true,isSee:false},
                    {id:11,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:true,isSee:false},
                    {id:12,name:"123",nameA:"234",nameB:"345",nameC:"345",nameD:"345",nameE:"345",nameF:"345",nameG:"345",nameH:"345",nameI:"345",nameJ:"345",nameK:"345",isEdit:true,isDelete:true,isSee:false}
                ],
                last_page:10,
                current_page:1,
                total:1000,
                selectRow:[]
            }
        },
        methods:{

            //publicFunc
            getPage(obj){
                this.current_page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(id){
                this.pl(id)
            },
            getTableDelete(id){
                this.pl(id)
            },
            getTableSee(id){
                this.pl(id)
            },
            getTableEdit(id){
                this.pl(id)
            },
            getRow(row){
                this.selectRow=row;
            },
            changetable(){
                this.tableData.forEach(item=>{
                    item.nameA="321"
                })
                this.tableCol[4].isShow=!this.tableCol[4].isShow;
            }
        },
        components:{
            tabletem,
            pagination
        }
    }
</script>
